<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class='lt-scene' ref='ltScene'>
    <!-- <TemporaryControls v-if='isDevelopment'> -->
      <!-- eslint-disable -->
      <!-- <div>
        <strong>window:</strong> {{ windowWidth }}x{{ windowHeight }}<br />
        <strong>scene: </strong> {{ sceneWidth }}x{{ sceneHeight }}<br />
      </div>

      <template v-slot:table>
        <tr>
          <td>Left</td>
          <td>
            <input
              v-model.number="leftPositionSelected"
              type="number"
              min='0'
              :max='maxLeft'
              step='20'
            />
          </td>
        </tr>
      </template>

      <template v-slot:footer>
        <strong>activeRefName:</strong> {{ activeRefName }}
      </template>

      <template v-slot:mini>

      </template> -->
      <!-- eslint-enable -->
    <!-- </TemporaryControls> -->

    <!-- Order of following items is important for overlaying -->
    <img class="lt-scene_background" src="../assets/background-base.svg" ref="backgroundBase" alt="" />
    <EatOutWindow ref='sect_eatout' />
    <TransportWindow ref='sect_transport' />

    <Transition name="fade" v-show='house > 0' appear>
      <div class='lt-scene_coving' ref='sect_house_1'></div>
    </Transition>

    <Transition name="slideY-down" v-show="house > 1">
      <img
        src="../assets/art.svg"
        class='lt-scene_art'
        ref='sect_house_2'
        alt=""
      />
    </Transition>

    <!-- lights -->

    <Transition name="slideY-down" v-show="house == 1">
      <img
        src="../assets/lamp1.svg"
        class='lt-scene_light_1'
        ref='sect_house_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="house == 2">
      <img
        src="../assets/lamp2.svg"
        class='lt-scene_light_2'
        ref='sect_house_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="house == 3">
      <img
        src="../assets/lamp3.svg"
        class='lt-scene_light_3'
        ref='sect_house_2'
        alt=""
      />
    </Transition>

    <!-- music stereo -->

    <Transition name="slideY-down" v-show="communications == 1">
      <img
        src="../assets/music1.svg"
        class='lt-scene_music_1'
        ref='sect_communications_1'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="communications == 2">
      <img
        src="../assets/music2.svg"
        class='lt-scene_music_2'
        ref='sect_communications_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="communications == 3">
      <img
        src="../assets/music3.svg"
        class='lt-scene_music_3'
        ref='sect_communications_3'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="communications > 0">
      <img
        src="../assets/comms-1.svg"
        class='lt-scene_communications'
        ref='sect_communications_1'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="communications > 1">
      <img
        src="../assets/comms-2.svg"
        class='lt-scene_communications'
        ref='sect_communications_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="communications > 2">
      <img
        src="../assets/comms-3.svg"
        class='lt-scene_communications'
        ref='sect_communications_3'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="holiday > 0">
      <img
        src='../assets/holiday-1.svg'
        class='lt-scene_holiday-1'
        ref='sect_holiday_1'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="holiday > 1">
      <img
        src='../assets/holiday-2.svg'
        class='lt-scene_holiday-2'
        ref='sect_holiday_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="holiday > 2">
      <img
        src='../assets/holiday-4.svg'
        class='lt-scene_holiday-4'
        ref='sect_holiday_2'
        alt=""
      />
    </Transition>

    <Transition name="fade" v-show="house > 2" appear>
      <img
        src="../assets/lamp.svg"
        class='lt-scene_lamp'
        alt=""
      />
    </Transition>

    <div class='lt-scene_windows'></div>

    <DiningTable ref='sect_food' />

    <Transition v-show="house === 1">
      <Shelf ref='sect_holiday_3' />
    </Transition>

    <Transition name="slideY-down" v-show="house > 1">
      <Cupboard ref='sect_holiday_3' />
    </Transition>

    <Transition name='slideX-left' v-show="house > 0">
      <div class='lt-scene_sofas'></div>
    </Transition>

    <PersonalItems ref='sect_personal' />

    <Transition
      name='slideX-right'
      v-show="house > 2"
    >
      <img
        src='../assets/sideboard.svg'
        class='lt-scene_sideboard'
        ref='sect_house_3'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="leisure > 0">
      <img
        src='../assets/treat-1.svg'
        class='lt-scene_leisure-1'
        ref='sect_leisure_1'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="leisure > 1">
      <img
        src='../assets/treat-2.svg'
        class='lt-scene_leisure-2'
        ref='sect_leisure_2'
        alt=""
      />
    </Transition>

    <Transition name="slideY-down" v-show="leisure > 2">
      <img
        src='../assets/treat-3.svg'
        class='lt-scene_leisure-3'
        ref='sect_leisure_3'
        alt=""
      />
    </Transition>

    <div :class="['lt-scene_overlay', showOverlay ? 'lt-scene_overlay--active' : '']"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations } from 'vuex';
import { mapFields } from "vuex-map-fields";
import anime from "animejs";

// import TemporaryControls from "./TemporaryControls";

import Cupboard from "./scene-items/Cupboard";
import DiningTable from "./scene-items/DiningTable";
import EatOutWindow from "./scene-items/EatOutWindow";
import PersonalItems from "./scene-items/PersonalItems";
import Shelf from "./scene-items/Shelf";
import TransportWindow from "./scene-items/TransportWindow";

export default {
  components: {
    Cupboard,
    DiningTable,
    EatOutWindow,
    PersonalItems,
    Shelf,
    TransportWindow,

    // TemporaryControls,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      leftPositionSelected: 0,
      windowWidth: 0,
      windowHeight: 0,
      sceneWidth: 0,
      sceneHeight: 0,
    };
  },

  computed: {
    ...mapFields([
      'scene.status.leisure',
      'scene.status.house',
      'scene.status.communications',
      'scene.status.holiday',
      'ui.showForeground',
    ]),
    ...mapGetters([
      'activeItem',
      'isOnPage',
      'isDevelopment',
    ]),
    maxLeft: function() {
      return Math.abs(this.windowWidth - this.sceneWidth);
    },
    leftPosition: function() {
      const validLeftPosition = _.clamp(Math.max(0, this.leftPositionSelected), 0, this.maxLeft);
      return 0 - validLeftPosition;
    },
    showOverlay: function() {
      const isNotLoading = this.isOnPage('loading') === false;
      return isNotLoading && this.showForeground;
    },
    activeRefName: function() {
      const item = this.activeItem;

      if (item.status === 0) {
        return '';
      }
      else if (_.has(this.$refs, `sect_${item.name}_${item.status}`)) {
        return `sect_${item.name}_${item.status}`;
      }
      else if (_.has(this.$refs, `sect_${item.name}`)) {
        return `sect_${item.name}`;
      }
      return '';
    },
    loadingLoop: function() {
      const duration = this.maxLeft * 10;

      return anime({
        targets: this.$refs.ltScene,
        left: `-${this.maxLeft}px`,
        easing: "linear",
        autoplay: false,
        duration,
        loop: true,
        direction: 'alternate',
      });
    },
  },

  watch: {
    activeRefName(ref) {
      if (ref && ref.length > 0) {
        this.goTo(ref);
      }
    },
    isLoading(newVal) {
      if (newVal) {
        this.loadingLoop.play();
      }
      else {
        this.loadingLoop.pause();
      }
    },
  },

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getSceneDimensions);
      this.$refs.backgroundBase.onload = this.getSceneDimensions;
      this.getSceneDimensions();
    });
  },

  methods: {
    ...mapMutations([
      'applyChangesToScene',
      'setIsAnimating',
      'goToNextPage',
    ]),
    getSceneDimensions() {
      this.windowWidth = document.getElementById('ahc-lifetime-find-your-future-wrapper').clientWidth;
      this.windowHeight = document.getElementById('ahc-lifetime-find-your-future-wrapper').clientHeight;

      this.$refs.backgroundBase.style.height = `${this.windowHeight}px`;

      this.sceneWidth = this.$refs.backgroundBase.clientWidth;
      this.sceneHeight = this.$refs.backgroundBase.clientHeight;

      this.tempCssRefresh = !this.tempCssRefresh;
    },

    goTo(elementRef) {
      const lastLeftPosition = this.leftPosition;

      if (this.windowWidth < this.sceneWidth) {
        const vueRef = this.$refs[`${elementRef}`];

        // If target is Vue component get it's HTML Element
        const targetElement = _.isElement(vueRef) ? vueRef : vueRef.$el;

        const targetMidPosition = targetElement.offsetLeft + (targetElement.clientWidth / 2);
        const windowMidPoint = this.windowWidth / 2;

        this.leftPositionSelected = targetMidPosition - windowMidPoint;
      }
      else {
        this.leftPositionSelected = 0;
      }

      const difference = Math.abs(this.leftPosition - lastLeftPosition);
      const duration = difference > 400 ? 300 : 150;
      const delayBeforeAddingToScene = 100;
      const itemAnimationTime = 1200;

      anime({
        targets: this.$refs.ltScene,
        translateX: ['0px', `${this.leftPosition}px`],
        easing: "linear",
        duration,
        complete: () => {
          setTimeout(() => {
            this.applyChangesToScene();

            setTimeout(() => {
              this.showForeground = true;
              this.goToNextPage();
              this.setIsAnimating(false);
            }, this.windowWidth > 390 ? itemAnimationTime : 0);

          }, this.windowWidth > 390 ? delayBeforeAddingToScene : 0)
        },
      });
    },
  },
};

</script>
